import { ARRAY_DEFAULT, FUNC_DEFAULT } from 'constants';
import { useEffect, useRef, useState } from 'react';

const useCountdownToActionVer2 = ({
  countdownInit = 0,
  isRun = false,
  cb = FUNC_DEFAULT,
  deps = ARRAY_DEFAULT,
  delaySec = 1,
  isLoop = false,
}) => {
  const [countdown, setCountdown] = useState(countdownInit);

  const timer = useRef(null);

  const loopCallback = () => {
    setCountdown(countdownInit);
  };

  useEffect(() => {
    let timerTimeOut = timer?.current;

    const cleanupTimeOut = () => {
      clearTimeout(timerTimeOut);
    };

    if (isRun) {
      timerTimeOut = setTimeout(() => {
        setCountdown((count) => count - 1);
      }, delaySec * 1000);
    }

    if (countdown === -1) {
      if (!isLoop) {
        cb();
        cleanupTimeOut();
        return;
      }

      cb(loopCallback);
    }

    return () => {
      cleanupTimeOut();
    };
  }, [countdown, ...deps]);

  return { countdown };
};

export default useCountdownToActionVer2;
